function updateCustomProduct(){
  //console.log($(this).data('product'));

  let $base_option = $('#bundle-base-product option:selected')
  let base_price = $base_option.data('price'); 

  let options_price = 0
  let discount_total = 0
  
  const add_bundle = $('#add-bundle')

  console.log( $base_option.text().indexOf('Sold Out') );
  
  if ( $base_option.text().indexOf('Sold Out') === -1 ) {
    add_bundle.prop('disabled', false);
    add_bundle.text('Add To Cart');
    $('.klaviyo-bis-trigger').hide();
  } else {
    add_bundle.prop('disabled', true);
    add_bundle.text('Sold Out');
    $('.klaviyo-bis-trigger').show();
  }

  $('.options select.accessory option:selected').each(function(i) {
    option_price = $(this).data('price')
    if (typeof option_price != 'undefined') {
      options_price = options_price + $(this).data('price');
    }
  });


  $('#base-total').html( Shopify.formatMoney(base_price) )
  $('#accessories-total').html( Shopify.formatMoney(options_price) )
  $('#bundle-total').html( Shopify.formatMoney( base_price + options_price ) );
  
  if ( bundle_discount != 0 ) {
	  discount_invert = 100 - bundle_discount;

	  discount_value =  ( options_price * bundle_discount ) / 100;
	  discount_total =  ( options_price * discount_invert ) / 100;
	  
	  $('#bundle-subtotal').html( Shopify.formatMoney( base_price + options_price ) )	
	  $('#bundle-discount').html( '-'+Shopify.formatMoney(discount_value) )
	  $('#bundle-total').html( Shopify.formatMoney( base_price + options_price - discount_value ) );
  }
  
  let base_img = $base_option.data('img'); 
  $('#base-img').attr('src', base_img);
}

$('.c-section__one-wheel select').change(function(){
  elem = $(this)
  let layer_div = $('#'+elem.data('product')+'-layer');
  let layer_img = elem.find(":selected").data('img');
  
  if (typeof layer_img != 'undefined') {
    layer_div.show();
    layer_div.html('<img src="'+layer_img+'"/>');
  } else {
    layer_div.hide();
  }
    
  updateCustomProduct()
});

$('#bundle-base-product').change(function(){
  updateCustomProduct();
});


$( document ).ready(function() {
  if (typeof bundle_discount != 'undefined') {
    updateCustomProduct();
  }
});

function addBundle(bundle_products){
	
	$('.options select option:selected').each(function(i) {
		option_val = $(this).val()
		if (option_val != '') {
			bundle_products.push($(this).val())
		}
	});
	
	Shopify.moveAlong = function() {
		if (bundle_products.length) {
			var request = bundle_products.shift();

			dataObj = {        
				quantity: 1, 
				id: request,
			};

			$.ajax({
				type: 'POST',
				url: '/cart/add.js',
				dataType: 'json',
				data: dataObj,
				success: function(res){
					console.log("added: " + request);
					Shopify.moveAlong();
				},
				error: function(error){
					console.log(error);
					console.log("error: " + request);
					Shopify.moveAlong()
				}
			});
		}
		else {
			// If the queue is empty, show confirmation popup
			console.log('completed - success')
			window.location.href = "/cart";						
		}
	};
	Shopify.moveAlong();
}

$('#add-bundle').click(function(){
  $(this).text('Adding To Cart');
  bundle_products = [];
  addBundle(bundle_products)	
});

$('#add-bundle-accessories').click(function(){
  $(this).text('Adding To Cart');
  bundle_products = [ $('#bundle-base-product option:selected').val() ];
  addBundle(bundle_accessories)	
});

$('iframe[src*="youtube"]').wrap("<div class='video-container'></div>");
